import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IPartnerCreateParams,
  IPartnerResponse,
  IPartnersListParams,
  IPartnersListResponse,
  IPartnerUpdateParams,
} from "~/entity/Partners/model/schema";

const partnersServiceMap = {
  partners: "/partners",
};

export class PartnersService {
  static _routes = partnersServiceMap;

  static GET = {
    list: (
      params: IPartnersListParams,
    ): NetworkResponse<IPartnersListResponse> =>
      requestREST.get(partnersServiceMap.partners, { params }),

    byId: (id: string): NetworkResponse<IPartnerResponse> =>
      requestREST.get(`${partnersServiceMap.partners}/${id}`),
  };

  static POST = {
    create: (data: IPartnerCreateParams): NetworkResponse<IPartnerResponse> =>
      requestREST.post(partnersServiceMap.partners, data),
  };

  static PUT = {
    update: (
      id: string,
      data: IPartnerUpdateParams,
    ): NetworkResponse<IPartnerResponse> =>
      requestREST.put(`${partnersServiceMap.partners}/${id}`, data),
  };
}
